import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  // async clearCacheForFile(filename: string): Promise<void> {
  //
  //   // Name the cache something unique to not interfere with other caches.
  //   const cache = await caches.open('audience-plus-cache');
  //
  //   try {
  //     console.error(`Trying to clear ${filename} cache.`);
  //     const keys = await cache.keys();
  //
  //     for (const key of keys) {
  //       if (key.url.includes(filename)) {
  //         await cache.delete(key);
  //       }
  //     }
  //   } catch (error) {
  //     console.error(`Error clearing ${filename} cache:`, error);
  //   }
  // }

  /**
   * Clears all available browser Cache Storage entries for the current origin.
   * Safely no-ops when the Cache Storage API is unavailable and catches runtime
   * failures so callers do not need to handle cache-specific errors.
   * @returns Promise that resolves when cache-clear work is completed.
   */
  async clearCacheForApp(): Promise<void> {
    if (typeof globalThis !== 'undefined' && !('caches' in globalThis)) {
      // Caches not supported
      return;
    }
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    } catch (error) {
      console.error('Error clearing Audience+ cache:', error);
    }
  }
}
